/**
 * Background hero video (hp-hero, page-hero): loops muted and plays only while its section is in view
 * (also pauses when the tab is hidden).
 */
export const playVideo = (video) => {
    video.play().catch(() => {
        // Autoplay with sound is blocked by browsers → fall back to muted
        video.muted = true;
        video.play().catch(() => {});
    });
};

export const initHeroVideo = (section, video) => {
    const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
            playVideo(video);
        } else if (!video.paused) {
            video.pause();
        }
    }, {threshold: 0});

    observer.observe(section);

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            video.pause();
        } else if (section.getBoundingClientRect().bottom > 0) {
            playVideo(video);
        }
    });
};
